export const STAMPS_FETCH_START = "STAMPS_FETCH_START";
export const STAMPS_FETCH_COMPLETED = "STAMPS_FETCH_COMPLETED";



// WEBPACK FOOTER //
// ./src/actions/types.js